import React, { useEffect, useState } from 'react';
import PWAPrompt from 'react-ios-pwa-prompt';

const STORAGEKEY = 'installHeader';
const MAX_DISMISSALS = 1;
const RESET_INTERVAL = 30 * 24 * 60 * 60 * 1000;

const AppDownload: React.FC = () => {
  const isIOS = /ipad|iPhone|iPod/.test(navigator.userAgent);
  const isStandAloneMode = window.matchMedia('(display-mode: standalone)').matches;
  const [show, setShow] = useState<boolean>(false);

  useEffect(() => {
    const now = Date.now();
    const storeData = localStorage.getItem(STORAGEKEY);

    if (storeData) {
      const data = JSON.parse(storeData);

      const isDatePassed = now - data?.lastDismissDate >= RESET_INTERVAL;

      if (isDatePassed || data?.dismissCount < MAX_DISMISSALS) {
        localStorage.setItem(
          STORAGEKEY,
          JSON.stringify({
            dismissCount: isDatePassed ? 0 : data.dismissCount,
            lastDismissDate: now
          })
        );
        setShow(true);
      }
    } else {
      setShow(true);
    }
  }, []);

  const handleClose = () => {
    const now = Date.now();
    const storeData = localStorage.getItem(STORAGEKEY);
    let data;

    if (storeData) {
      data = JSON.parse(storeData);
      data.dismissCount += 1;
      data.lastDismissDate = now;
    } else {
      data = {
        dismissCount: 1,
        lastDismissDate: now
      };
    }

    localStorage.setItem(STORAGEKEY, JSON.stringify(data));
  };

  return (
    <>
      <PWAPrompt
        copyTitle={'Install OmniBlu'}
        isShown={show && isIOS && !isStandAloneMode}
        appIconPath={'./jbtMarelLogo.png'}
        copyDescription={
          'Install the app on your device to easily access it anytime. No app store. No download.No hassle.'
        }
        onClose={handleClose}
      />
    </>
  );
};

export default AppDownload;
